import React from 'react'
import Helmet from 'react-helmet'
import sortBy from 'lodash/sortBy'
import get from 'lodash/get'
import include from 'underscore.string/include'
import { config } from 'config'

import Identity from '../components/Identity'

// Posts are those with md extension that are not 404 pages OR have a date (meaning they're a react component post).
const BlogIndex = ({ route }) => {
  // Sort pages.
  const sortedPages = sortBy(route.pages, 'data.date')
  // Posts are those with md extension that are not 404 pages OR have a date (meaning they're a react component post).
  const visiblePages = sortedPages.filter(page => (
      get(page, 'file.ext') === 'md' && (!include(page.path, '/404') || get(page, 'data.date'))
    ))

  if (visiblePages.length > 0) {
    console.log(visiblePages)
  }

  return (
    <div>
      <Helmet
        title={config.blogTitle}
        meta={[
            { name: 'description', content: config.description },
            { name: 'keywords', content: config.keywords },
        ]}
      />
      <Identity />
    </div>
  )
}

BlogIndex.propTypes = {
  route: React.PropTypes.object,
}

export default BlogIndex



// WEBPACK FOOTER //
// ./index.jsx